 import { apiFetcher } from '@/api/api'
 import { useCacheSWR } from '@/api/swrCache'
 import { useMemo } from 'react'
 
 // 兑奖记录查询
 export function useExchangeRecord(filters: any) {
   const cacheKey: [string, Record<string, any>] = useMemo(() => ['useExchangeRecord', filters], [filters])
   
   const fetcher = () => {
     return apiFetcher(
       {
         path: '/act/api/v1/activityTopGift/exchangeRecord',
         type: 'post'
       },
       {
         arg: {...filters}
       }
     )
   }
   const result = useCacheSWR(cacheKey, fetcher, {dedupingInterval: 5 * 1000, author: true})
 
   const list = result.data?.data?.list ?? []
   const totalRecord = result.data?.data?.totalRecord ?? 0
   const totalPage =result.data?.data?.totalPage ?? Math.ceil(totalRecord / filters.pageSize)
   return{
     ...result,
     list,
     totalRecord,
     totalPage
   }
 }